var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelTiktok = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M18.998 10.473q-.201.02-.402.02a4.4 4.4 0 0 1-3.655-1.931v6.577c0 2.685-2.225 4.861-4.97 4.861C7.225 20 5 17.824 5 15.139s2.225-4.861 4.97-4.861c.104 0 .206.009.308.015v2.396c-.102-.012-.203-.03-.307-.03-1.402 0-2.537 1.11-2.537 2.48s1.135 2.482 2.537 2.482c1.4 0 2.638-1.08 2.638-2.45L12.634 4h2.343c.221 2.055 1.916 3.66 4.023 3.811v2.662",
  clipRule: "evenodd"
})));
export default SvgGemChannelTiktok;